import { c as _c } from "react/compiler-runtime";
import useFavoritedProductIds from 'hooks/useFavoritedProductIds';
import useStaticWishlistData from './useStaticWishlistData';
const useFavoritesStaticProductData = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      fetchPolicy: "cache-and-network"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data
  } = useFavoritedProductIds(t0);
  let t1;
  if ($[1] !== data?.productIds) {
    t1 = data?.productIds ?? [];
    $[1] = data?.productIds;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const productIds = t1;
  let t2;
  if ($[3] !== productIds) {
    t2 = {
      productIds
    };
    $[3] = productIds;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useStaticWishlistData(t2);
};
export default useFavoritesStaticProductData;